var React = require('react');

function ArrowForward (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"0,10.6 1.5,12 8,6 1.5,0 0,1.4 5,6 "}));
}

ArrowForward.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"8px","height":"12px","viewBox":"0 0 8 12","style":{"enableBackground":"new 0 0 8 12"},"xmlSpace":"preserve"};

module.exports = ArrowForward;

ArrowForward.default = ArrowForward;
